import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/white-icon-large.png";
import "./HeaderSm.scss";
import { UserProfile } from "./UserProfile";
import { URLCopyButton } from "./URLCopyButton";
import { AutoRefreshSwitch } from "./AutoRefreshSwitch";

interface HeaderSmProps {
  contactUsPath?: string;
  signOutPath?: string;
  customLogo?: React.ReactNode;
  headerCustomCSS?: string;
  onAutoReloadToggleChange: (toggle: boolean) => void;
  autoReloadToggleValue: boolean;
}

/**
 * App Header component for individual layouts. If the user is located in the landing page, clicking the title will return the user to the main site. Otherwise, it will link the user to the landing page
 * @returns Returns site header.
 */
const HeaderSm = (props: HeaderSmProps) => {
  const [isMounted, setIsMounted] = React.useState<boolean>(false);
  React.useEffect(() => {
    setIsMounted(true);
  }, []);

  const customHeaderCSS = props.headerCustomCSS
    ? " " + props.headerCustomCSS
    : "";

  const isUserInAutoReloadablePage: boolean =
    window.location.href.includes("productURL") &&
    window.location.href.includes("radius");

  return (
    <>
      <div className={"banner " + (isMounted && "sm") + customHeaderCSS}>
        <div className="banner-text">
          {props.customLogo ?? (
            <>
              <Link className="title" to="/landingpage">
                GALLUS INSIGHTS
              </Link>
            </>
          )}
        </div>
        <div className="banner-image">
          <div className="d-flex align-items-center">
            {!(
              window.location.pathname === "/landingpage" ||
              window.location.pathname === "/" ||
              window.location.href.includes("/contactus")
            ) && <URLCopyButton />}
            {isUserInAutoReloadablePage && (
              <AutoRefreshSwitch
                onChange={props.onAutoReloadToggleChange}
                autoReloadToggleValue={props.autoReloadToggleValue}
              />
            )}
            <UserProfile
              contactUsPath={props.contactUsPath}
              signOutPath={props.signOutPath}
            />
            <Link className="title" to="/">
              <img className="logo" src={Logo} alt="Gallus Insights" />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderSm;
